export default __webpack_public_path__ + "static/landing-image-b-67ac9eb6043ea2b0744e8ef8d51770d4.png";